import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/app/core/auth.guard';
import { BlogComponent } from './views/blog/blog.component';
import { PostGeneratorComponent } from './views/post-generator/post-generator.component';
import { PostComponent } from './views/post/post.component';

const routes: Routes = [
  {
    path: BlogComponent.route,
    component: BlogComponent,
    pathMatch: 'full',
  },
  {
    path: `${PostComponent.route}/:id`,
    component: PostComponent,
  },
  {
    path: `${PostGeneratorComponent.route}`,
    component: PostGeneratorComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BlogRoutingModule {
  static route = 'blog';
}
